import './css/tailwind.css';
import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
// Must load after third-party CSS so dark-mode overrides win on equal specificity.
import './css/dark-mode.css';
import './css/themes.css';
import './css/easter-eggs.css';
import BarkApp from './BarkRouter';
import { FallingEmojis } from './component/FallingEmojis';
import { TreatDrop } from './component/TreatDrop';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { preloadTldWhitelist } from './utils';

preloadTldWhitelist();

const ThemedToastContainer = () => {
  const { isDark } = useTheme();
  return <ToastContainer theme={isDark ? 'dark' : 'light'} />;
};

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOMClient.createRoot(rootElement);
  root.render(
    <ThemeProvider>
      <BarkApp />
      <ThemedToastContainer />
      <TreatDrop />
      <FallingEmojis />
    </ThemeProvider>
  );
}
